import { LESSON_URL_PATH, COURSE_URL_PATH } from 'src/utils/getUrl';

export const isStandalone = (): boolean => {
  const location = globalThis?.location;

  if (!location) {
    return false;
  }

  const { search, pathname } = location;

  const isLegacyStandalone = search?.includes('standalone=true');
  const isFullStandalone = pathname?.includes(`/${LESSON_URL_PATH}/`) && !pathname?.includes(`/${COURSE_URL_PATH}/`);

  return isLegacyStandalone || isFullStandalone;
};
